import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Quote} from '../../../Core/mobx/ParameterStore/Quote';
import Card from '@material-ui/core/Card';
import {NumberFormatCustom, SwitchCustom, TextBox} from '../../../Core/UI';
import {Prequal} from '../../../Core/mobx/ParameterStore/Prequal';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {FormType} from '../../PreQualification/types';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/QuoteXref';

type VULTabProps = {
    valueChanged: (p: Parameter, value: any, formType?: FormType) => void;
    parameters: Quote;
    refParameters: Prequal;
    formType: FormType;
};

const VULTab = observer(({valueChanged, parameters, refParameters, formType}: VULTabProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Carrier Product</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Product',
                                name: 'productVUL',
                                options: fieldOptions.productVUL.options,
                                ...parameters.productVUL,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
            </Card>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Basics</Typography>
                </div>
                <Grid container spacing={3}>
                    {parameters.ameritas.value && refParameters.age.value < 18 && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Health Rating',
                                    name: 'healthRatingAmeritasJuvenileVUL',
                                    options: fieldOptions.healthRatingAmeritasJuvenileVUL.options,
                                    optionValues: fieldOptions.healthRatingAmeritasJuvenileVUL.optionValues,
                                    ...parameters.healthRatingAmeritasJuvenileVUL,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    {parameters.ameritas.value && refParameters.age.value >= 18 && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Health Rating',
                                    name: 'healthRatingAmeritasAdultVUL',
                                    options: fieldOptions.healthRatingAmeritasAdultVUL.options,
                                    optionValues: fieldOptions.healthRatingAmeritasAdultVUL.optionValues,
                                    ...parameters.healthRatingAmeritasAdultVUL,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    {parameters.ameritas.value && (
                        <Grid item xs={6}>
                            <SelectInputElement
                                param={{
                                    label: 'Table Rating',
                                    name: 'tableRatingAmeritasVUL',
                                    options: fieldOptions.tableRatingAmeritasVUL.options,
                                    optionValues: fieldOptions.tableRatingAmeritasVUL.optionValues,
                                    ...parameters.tableRatingAmeritasVUL,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <SwitchCustom
                            param={{
                                name: 'flatExtra',
                                label: 'Flat Extra',
                                ...parameters.flatExtra,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    {parameters.flatExtra.value && (
                        <Grid item xs={12}>
                            <TextBox
                                id={'flatExtraPerm'}
                                label={'Policy Lifetime Flat Extra (per $1000)'}
                                value={parameters.flatExtraPerm?.value}
                                onChange={(value) => valueChanged(parameters.flatExtraPerm, value, formType)}
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                    )}
                    {parameters.flatExtra.value && (parameters.ameritas.value || parameters.northAmerican.value) && (
                        <>
                            <Grid item xs={6}>
                                <TextBox
                                    id={'flatExtraYears'}
                                    label={'Temporary Flat Extra Years'}
                                    value={parameters.flatExtraYears?.value}
                                    onChange={(value) => valueChanged(parameters.flatExtraYears, value, formType)}
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextBox
                                    id={'flatExtraTemp'}
                                    label={'Temporary Flat Extra Amount (per $1000)'}
                                    value={parameters.flatExtraTemp?.value}
                                    onChange={(value) => valueChanged(parameters.flatExtraTemp, value, formType)}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Card>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Coverage and Premium</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Premium Payment Frequency',
                                name: 'premiumFrequency',
                                options: fieldOptions.premiumFrequency.options,
                                optionValues: fieldOptions.premiumFrequency.optionValues,
                                ...parameters.premiumFrequency,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Solve Scenario',
                                name: 'solveScenarioVUL',
                                options: fieldOptions.solveScenarioVUL.options,
                                optionValues: fieldOptions.solveScenarioVUL.optionValues,
                                ...parameters.solveScenarioVUL,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    {parameters.solveScenarioVUL.value === 'Setpremiumsolveforminimumnonmecfaceamount' ||
                        (parameters.solveScenarioVUL.value === 'Setpremiumsolvefortargetfaceamount' && (
                            <Grid item xs={6}>
                                <TextBox
                                    id={'premiumAmountVUL'}
                                    label={required('Premium Amount')}
                                    value={parameters.premiumAmountVUL?.value}
                                    onChange={(value) => valueChanged(parameters.premiumAmountVUL, value, formType)}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </Grid>
                        ))}
                    {parameters.solveScenarioVUL.value === 'Setfaceamountsolveformaximumnonmecpremium' ||
                        (parameters.solveScenarioVUL.value === 'Setfaceamountsolvefortargetpremium' && (
                            <Grid item xs={6}>
                                <TextBox
                                    id={'faceAmountVUL'}
                                    label={required('Face Amount')}
                                    value={parameters.faceAmountVUL?.value}
                                    onChange={(value) => valueChanged(parameters.faceAmountVUL, value, formType)}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </Grid>
                        ))}
                    <Grid item xs={6}>
                        <TextBox
                            id={'premiumPayToAgeVUL'}
                            label={required('Premium Pay To Age')}
                            value={parameters.premiumPayToAgeVUL?.value}
                            onChange={(value) => valueChanged(parameters.premiumPayToAgeVUL, value, formType)}
                            type="number"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextBox
                            id={'mainRateVUL'}
                            label={required('Main Rate (in %)')}
                            value={parameters.mainRateVUL?.value}
                            onChange={(value) => valueChanged(parameters.mainRateVUL, value, formType)}
                            type="number"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Death Benefit Option',
                                name: 'deathBenefitOptionVUL',
                                options: fieldOptions.deathBenefitOptionVUL.options,
                                optionValues: fieldOptions.deathBenefitOptionVUL.optionValues,
                                ...parameters.deathBenefitOptionVUL,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    {parameters.deathBenefitOptionVUL.value === 'IncreasingthenLevel' && (
                        <Grid item xs={6}>
                            <TextBox
                                id={'deathBenefitChangeAgeVUL'}
                                label={required('Death Benefit Change Age')}
                                value={parameters.deathBenefitChangeAgeVUL?.value}
                                onChange={(value) =>
                                    valueChanged(parameters.deathBenefitChangeAgeVUL, value, undefined)
                                }
                                type="number"
                            />
                        </Grid>
                    )}
                </Grid>
            </Card>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <div>
                    <Typography style={{fontWeight: 'bold', fontSize: 24}}>Coverage and Premium Details</Typography>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Compliance Test',
                                name: 'complianceTestVUL',
                                options: fieldOptions.complianceTestVUL.options,
                                optionValues: fieldOptions.complianceTestVUL.optionValues,
                                ...parameters.complianceTestVUL,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    {parameters.complianceTest.value !== 'CashValueAccumulationTest' && (
                        <Grid item xs={4}>
                            <SwitchCustom
                                param={{
                                    name: 'mecAvoidance',
                                    label: 'MEC Avoidance',
                                    ...parameters.mecAvoidance,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                                formType={formType}
                            />
                        </Grid>
                    )}
                </Grid>
            </Card>
        </>
    );
});

export default VULTab;
